import { ExperienceConfigurationKeys } from '@monetize/types/experience-config';
import { useExperienceConfiguration } from '../../../hooks';
import { useACL } from '../../../services/acl/acl';
import { useAuth } from '../../../services/auth0';

export const useCanCreateQuote = () => {
  const { canDo } = useACL();
  const { quoteCreateAllowedRoles } = useExperienceConfiguration(
    ExperienceConfigurationKeys.quoteAndContractSettings,
  );
  const { currentTenantUserHasRole } = useAuth();

  const canCreateQuote =
    canDo([['sales', 'create']]) &&
    (!quoteCreateAllowedRoles?.length ||
      currentTenantUserHasRole(quoteCreateAllowedRoles));

  return canCreateQuote;
};
